import { createSelector } from '@ngrx/store';
import IRootState from './root.state';

export const selectRoot = (state: { root: IRootState }) => state.root;

export const selectHasSubdomainBeenChecked = createSelector(
  selectRoot,
  (root) => root.customSubdomain !== null,
);

export const selectCustomSubdomain = createSelector(
  selectRoot,
  (root) => root.customSubdomain ?? '',
);
